import React from "react";
import "../../../styles/pulse/screens/unified_profile/unsaved-close-dialog.css";

function showExitDislog(exitCallback, goSaveCallback, isRequireSave) {
  const actions = [];

  if (!isRequireSave) {
    actions.push({
      label: this.appData.settings.translations.unsaved_dialog_exit_lable,
      onClick: () => exitCallback(),
      className: "do-not-save"
    });
  }

  actions.push({
    label: this.appData.settings.translations.unsaved_dialog_save_lable,
    onClick: () => goSaveCallback(),
    className: "go-back-save"
  });

  this.dialog.showDialog({
    content: {
      title: this.appData.settings.translations.unsaved_dialog_title,
      children: (
        <p className='dialog-description'>
          {this.appData.settings.translations.unsaved_dialog_description}
        </p>
      )
    },
    actions: actions
  });
}

export default showExitDislog;
